/* WM Footer v2 (2026-10-18)
   1) Link columns are details elements: accordions under 750px, always open at 750px and up.
   2) Email signup posts to the same Mailchimp list as before, via JSONP (post-json), so the
      shopper stays on the page. If JSONP fails or takes more than 8s, the form submits normally
      to Mailchimp in a new tab, as the old footer did.
*/
(function () {
  var root = document.querySelector('[data-wmf]');
  if (!root) return;

  /* Accordions */
  var mq = window.matchMedia('(min-width: 750px)');
  var accs = root.querySelectorAll('details.wmf-acc');
  function sync() {
    for (var i = 0; i < accs.length; i++) {
      if (mq.matches) accs[i].setAttribute('open', '');
      else accs[i].removeAttribute('open');
    }
  }
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
  root.addEventListener('click', function (e) {
    var sum = e.target.closest ? e.target.closest('summary.wmf-h') : null;
    if (sum && mq.matches) e.preventDefault();
  });

  /* Signup */
  var form = root.querySelector('[data-wmf-signup]');
  if (!form) return;
  var input = form.querySelector('input[type="email"]');
  var btn = form.querySelector('button[type="submit"]');
  var msg = form.querySelector('.wmf-form__msg');
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function say(text, state) {
    msg.textContent = text || '';
    if (state) form.setAttribute('data-state', state);
    else form.removeAttribute('data-state');
  }
  function nativeSubmit() {
    say('', '');
    btn.disabled = false;
    HTMLFormElement.prototype.submit.call(form);
  }

  input.addEventListener('input', function () {
    if (input.getAttribute('aria-invalid') === 'true' && EMAIL_RE.test(input.value.trim())) {
      input.removeAttribute('aria-invalid');
      say('', '');
    }
  });

  form.addEventListener('submit', function (e) {
    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      e.preventDefault();
      input.setAttribute('aria-invalid', 'true');
      say('Please enter a valid email address, like name@example.com.', 'error');
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/subscribe/post?') === -1) return; /* not Mailchimp: submit normally */
    e.preventDefault();

    var cb = 'wmfMc' + Date.now();
    var done = false;
    var tag = document.createElement('script');
    var fields = form.querySelectorAll('input[name]');
    var qs = [];
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      qs.push(encodeURIComponent(f.name) + '=' + encodeURIComponent(f.name === 'EMAIL' ? email : f.value));
    }
    var url = action.replace('/subscribe/post?', '/subscribe/post-json?') + '&' + qs.join('&') + '&c=' + cb;

    function cleanup() {
      try { delete window[cb]; } catch (err) { window[cb] = undefined; }
      if (tag.parentNode) tag.parentNode.removeChild(tag);
    }
    var timer = setTimeout(function () {
      if (done) return;
      done = true; cleanup(); nativeSubmit();
    }, 8000);

    window[cb] = function (res) {
      if (done) return;
      done = true; clearTimeout(timer); cleanup(); btn.disabled = false;
      var text = String((res && res.msg) || '').replace(/<[^>]*>/g, '').replace(/^\d+\s*-\s*/, '').trim();
      if (res && res.result === 'success') {
        input.value = '';
        say(form.getAttribute('data-success') || 'Thanks for signing up!', 'success');
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'wm_footer_signup' }); } catch (err) {}
      } else if (/already subscribed/i.test(text)) {
        say("You're already on our list. Thanks for being a subscriber!", 'success');
      } else {
        say(text || 'Something went wrong. Please try again.', 'error');
      }
    };
    tag.onerror = function () {
      if (done) return;
      done = true; clearTimeout(timer); cleanup(); nativeSubmit();
    };

    btn.disabled = true;
    say('Signing you up…', 'busy');
    tag.src = url;
    document.body.appendChild(tag);
  });
})();
